module.exports = __webpack_public_path__ + "img/steam_wishlist_small.bd26c722.png";